import CustomerCard from "./customerCard";

const CustomerGrid = ({ data, clientType, onOpenDetails }) => {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 p-4 bg-white border-x-2 border-b-2 rounded-b-xl">
            {data.map((item) => (
                <CustomerCard 
                    key={item.login} 
                    item={item} 
                    clientType={clientType} 
                    onClick={onOpenDetails} 
                />
            ))}
        </div>
    );
};

export default CustomerGrid;